import React from 'react';
import { isEqual } from 'lodash';
import LinkLibrary from 'src/constrains/LinkLibrary';

const Link = (props) => {
  const { onChange, value, id, linkSet, linkProps } = props;
  const [link, setLink] = React.useState(value);
  React.useEffect(() => {
    if (!isEqual(value, link)) {
      setLink(value);
    }
  }, [value]);

  const onLinkChange = (l) => {
    setLink(l);
    onChange(l);
  };

  //console.log('params', params);
  return (
    <LinkLibrary
      //   error={linkTypeErrorArray
      //     .map((err) => (errCodesMap[err] ? errCodesMap[err] : err))
      //     .join('')}
      //mode={'no-modal'}
      noWrapper
      data={link || {}}
      onChange={onLinkChange}
      id={id}
      linkSet={linkSet}
      {...(linkProps || {})}
    />
  );
};
export default Link;
